import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How the card is chosen",
  "description": "",
  "published": "2009-12-18T00:00:00.000Z",
  "redirect_from": ["/blog/how-the-card-is-chosen/swizec/1011"],
  "categories": "life, Luck, Randomness, Subconscious, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/12/IMG00084.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/IMG00084.jpg",
          "alt": "The Hat",
          "title": "The Hat"
        }}></img></a>{` Upon first meeting people most of their attention is devoted to the card I have stuck in my hat.`}</p>
    <p>{`Upon second time meeting a person their questions about the card suddenly become `}<em parentName="p">{`hey didn't you have a different card last time?`}</em>{` Well yeah, I do change it every day dude ...`}</p>
    <p>{`This quickly becomes, well why the fuck do you keep changing it? How the fuck do you pick? Blahblahblah.`}</p>
    <p>{`So here's the answer guys, this is how I choose my card every day and all the considerations that go into the selection.`}</p>
    <p>{`First and foremost - simplicity uber alles! The simpler and less complex the card is, the more likely it is to end up on my hat. This also means that only hearts and spades get chosen. Diamonds are too pointy and weird, and that other thingy I don't even know the name of in english, is just too complex and convoluted a symbol. Euch!`}</p>
    <p>{`Secondly, the colour of the card alternates between days. If the prior day had a spade, next day it will be a heart and so on. I also try my best not to wear the same card twice in a week because that's just silly.`}</p>
    <p>{`Thirdly, if the hat hasn't been worn all day and is being put on just for a party or some other social event - the joker is chosen. It used to be that I had a nudie card stuck between the normal card at all times and then would swap them for social events (it's '`}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Luck",
        "title": "Luck"
      }}>{`bad luck`}</a>{`' to change cards twice in a day). But I lost that one.`}</p>
    <p>{`The rest is completely random. So you could say my `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Subconscious",
        "title": "Subconscious"
      }}>{`subconscious mind`}</a>{` picks a card according to the weights I've put in place. Now, some people say this is a terribly bad answer because it doesn't tell a story. But it does, it tells a great story.`}</p>
    <p>{`You'll notice that most of the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Major_religious_groups",
        "title": "Major religious groups"
      }}>{`world's religions`}</a>{`, belief structures and pretty much everything humans ever do in life, is governed by `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Randomness",
        "title": "Randomness"
      }}>{`randomness`}</a>{`. We call them acts of god, faith, yada yada, but at their core, they are simply events so damn random human minds can't wrap around them so they pull a reason out of thin air to feel a bit better about it. We don't like thinking things are random, we want to feel there is at least some structure ... somewhere ... somehow.`}</p>
    <p>{`But I reject that! I embrace randomness! I love randomness! Randomness is king!`}</p>
    <p>{`And that's why the card is random. The weights give selections a bit of a pattern, but mostly it's very random.`}</p>
    <p>{`Now stop asking me.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/15112c01-6121-4a5e-a6bf-ab2544c79571/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=15112c01-6121-4a5e-a6bf-ab2544c79571",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      